/**
 * ProductSeeInRealLifeSlider Custom Element
 * Handles the Swiper carousel for the "See it in Real Life" section
 */
class ProductSeeInRealLifeSlider extends HTMLElement {
  constructor() {
    super();
    this.swiper = null;
  }

  connectedCallback() {
    // Only initialize if Swiper is available and element is in DOM
    if (typeof Swiper !== 'undefined' && this.isConnected) {
      this.initSlider();
    }
  }

  disconnectedCallback() {
    // Clean up Swiper instance when element is removed
    if (this.swiper) {
      this.swiper.destroy();
      this.swiper = null;
    }
  }

  initSlider() {
    const sectionId = this.getAttribute('data-section-id');
    if (!sectionId) return;

    const swiperContainer = this.querySelector('.swiper');
    const prevButton = this.querySelector('.slider-button--prev');
    const nextButton = this.querySelector('.slider-button--next');

    if (!swiperContainer) return;

    try {
      this.swiper = new Swiper(swiperContainer, {
        slidesPerView: 1.3,
        spaceBetween: 10,
        loop: false,
        autoplay: {
          delay: 13000,
          disableOnInteraction: false
        },
        navigation: {
          nextEl: prevButton,
          prevEl: nextButton,
        },
        breakpoints: {
          600: {
            slidesPerView: 2.3,
            spaceBetween: 10,
          },
          750: {
            slidesPerView: 3.3,
            spaceBetween: 10,
          },
          1000: {
            slidesPerView: 4,
            spaceBetween: 10,
          },
          1300: {
            slidesPerView: 4,
            spaceBetween: 10,
          }
        },
      });
    } catch (error) {
      console.error('Error initializing ProductSeeInRealLifeSlider:', error);
    }
  }
}

// Register the custom element
if (!customElements.get('product-see-in-real-life-slider')) {
  customElements.define('product-see-in-real-life-slider', ProductSeeInRealLifeSlider);
}
